const backend=(process.env.REACT_APP_BACKEND_URL||'').replace(/\/+$/,'');
export const BASE=backend.endsWith('/api')?backend:backend+'/api';
export async function api(path,{method='GET',body,...options}={}){
 const form=body instanceof FormData;
 const response=await fetch(BASE+path,{method,credentials:'include',headers:form?{}:{'Content-Type':'application/json'},body:body?(form?body:JSON.stringify(body)):undefined,...options});
 if(!response.ok){let data;try{data=await response.json()}catch{data={detail:'Service indisponible'}};throw new Error(typeof data.detail==='string'?data.detail:JSON.stringify(data.detail));}
 return response.json();
}
export const post=(p,body)=>api(p,{method:'POST',body});
export const put=(p,body)=>api(p,{method:'PUT',body});
export const del=p=>api(p,{method:'DELETE'});
